'use client';

import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';

export function DatadogRumInitializer({
  serviceName,
  serviceVersion,
  hasUserConsent
}: {
  serviceName: string;
  serviceVersion: string;
  hasUserConsent: boolean;
}) {
  const isInitializedRef = useRef(false);
  const { environment } = useRequestContext();

  useEffect(() => {
    if (!hasUserConsent) return;
    if (isInitializedRef.current) return;
    if (environment !== 'production') return;

    datadogRum.init({
      applicationId: '4522792d-79d4-4b9f-b91a-c089a1b26f65',
      clientToken: 'pub76f21b829ffc9b541446363034830cfd',
      site: 'datadoghq.eu',
      service: serviceName,
      version: serviceVersion,
      env: 'production',
      sessionSampleRate: 1,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input'
    });

    isInitializedRef.current = true;
  }, [serviceName, serviceVersion, hasUserConsent, environment]);

  return null;
}
